/**
 * @description value of {@link UETag.FONT_FAMILY_SELECT} returned when user selects 'Add custom font' option
 */
export const ADD_CUSTOM_FONT_OPTION = 'ADD_CUSTOM_FONT_OPTION';
